<div class="upper-space">
  {{
    ipBoard.boardPart?.sign?.type?.value === SIGN_TYPE_CHOICES.STICKER.value ||
    ipBoard.boardPart?.otherIPBoardPartType?.ordinal ===
      IP_BOARD_PART_TYPE_CHOICES.ADHESIVE_BOARD.ordinal
      ? 'Kleefbord:'
      : 'Standaard IP-bord:'
  }}
  <span class="strong">{{
    ipBoard.boardPart?.sign?.type?.value === SIGN_TYPE_CHOICES.STICKER.value ||
      ipBoard.boardPart?.otherIPBoardPartType?.ordinal ===
        IP_BOARD_PART_TYPE_CHOICES.ADHESIVE_BOARD.ordinal
      | formatIPBoardDimensions
        : ipBoard.boardPart?.sign?.signMeasurements?.height
        : ipBoard.boardPart?.sign?.signMeasurements?.width
        : ipBoard.boardPart?.sign?.shape?.value ===
            SIGN_SHAPE_TYPE_CHOICES.UPRIGHT.value
        : ipBoard.boardPart?.otherHeight
        : ipBoard.boardPart?.otherWidth
  }}</span>
</div>

<div class="form-title upper-space">
  <div class="form-title-text">
    Configureer uw
    {{
      ipBoard.boardPart?.sign?.type?.value ===
        SIGN_TYPE_CHOICES.STICKER.value ||
      ipBoard.boardPart?.otherIPBoardPartType?.ordinal ===
        IP_BOARD_PART_TYPE_CHOICES.ADHESIVE_BOARD.ordinal
        ? 'kleefbord'
        : 'bord'
    }}
  </div>
</div>

<div class="d-flex">
  <div class="content-part">
    <ng-container
      *ngTemplateOutlet="
        title;
        context: {
          collaborative: project.collaborative,
          ipBoard: ipBoard,
          ipBoardPart: ipBoard.boardPart,
          title: 'Links'
        }
      "
    ></ng-container>
    <ng-container *ngIf="ipBoard.leftRightBoard">
      <ng-container
        *ngTemplateOutlet="
          title;
          context: {
            collaborative: project.collaborative,
            ipBoard: ipBoard,
            ipBoardPart: ipBoard.otherSideBoardPart,
            title: 'Rechts'
          }
        "
      ></ng-container>
    </ng-container>
    <ng-container *ngIf="!oldSystemImmo">
      <ng-container
        *ngTemplateOutlet="
          phone;
          context: {
            collaborative: project.collaborative,
            ipBoard: ipBoard,
            ipBoardPart: ipBoard.boardPart,
            title: 'Links'
          }
        "
      ></ng-container>
      <ng-container *ngIf="ipBoard.leftRightBoard">
        <ng-container
          *ngTemplateOutlet="
            phone;
            context: {
              collaborative: project.collaborative,
              ipBoard: ipBoard,
              ipBoardPart: ipBoard.otherSideBoardPart,
              title: 'Rechts'
            }
          "
        ></ng-container>
      </ng-container>
    </ng-container>
    <ng-container *ngIf="!oldSystemImmo">
      <ng-container
        *ngTemplateOutlet="
          text;
          context: {
            ipBoard: ipBoard,
            ipBoardPart: ipBoard.boardPart,
            title: 'Links'
          }
        "
      ></ng-container>
      <ng-container *ngIf="ipBoard.leftRightBoard">
        <ng-container
          *ngTemplateOutlet="
            text;
            context: {
              ipBoard: ipBoard,
              ipBoardPart: ipBoard.otherSideBoardPart,
              title: 'Rechts'
            }
          "
        ></ng-container>
      </ng-container>

      <div class="upper-space">
        <file-picker
          [inputProduct]="ipBoard"
          [formSection]="'externalDesign'"
          [client]="client"
          [uploadButtonLabel]="'Uw logo'"
          [hideUploadedImages]="true"
          (answer)="displayAssetsChanged()"
          (assetDeleted)="displayAssetsChanged()"
        ></file-picker>
      </div>

      <textarea-input
        [minHeight]="200"
        [placeholder]="
          'Dienen onze ontwerpers iets grafisch te wijzigen aan het bord: Noteer dit hier'
        "
        [initContent]="ipBoard.generalExtraInfo"
        [client]="client"
        (answer)="generalExtraInfoChanged($event)"
      ></textarea-input>
    </ng-container>
  </div>
  <div class="image-preview-part">
    <div
      *ngIf="
        ipBoard.boardPart?.otherIPBoardPartType?.ordinal !==
        IP_BOARD_PART_TYPE_CHOICES.ADHESIVE_BOARD.ordinal
      "
      class="upper-space"
    >
      <ip-board-design-preview
        [ipBoard]="ipBoard"
        [project]="project"
        [withFrame]="true"
        [showCustomSignExample]="true"
      ></ip-board-design-preview>
    </div>
    <ng-container *ngIf="displayAssetStyles?.length > 0">
      <div class="upper-space display-asset-container">
        <div class="frame">
          <div
            *ngFor="let style of displayAssetStyles"
            class="graphics-file-example clickable"
            [ngStyle]="style.style"
            (click)="openLightbox(style.productAsset)"
          >
            <mat-icon
              class="delete-button clickable"
              svgIcon="close"
              matTooltip="Verwijder bestand"
              [matTooltipPosition]="'above'"
              (click)="deleteGraphicsFile($event, style)"
            ></mat-icon>
          </div>
        </div>
      </div>
    </ng-container>
    <div class="pdfs-container upper-space" *ngIf="pdfList?.length > 0">
      <ul>
        <li *ngFor="let pdf of pdfList">
          <div>
            <a
              target="_blank"
              [href]="
                pdf.productAsset.asset.uuid
                  | assetSource : pdf.productAsset.asset.localSafeUrl
              "
              style="margin-right: 7px"
              class="d-flex box"
            >
              <mat-icon> picture_as_pdf </mat-icon>
              <div class="filename">{{ pdf.productAsset.asset.name }}</div>
            </a>
            <mat-icon
              class="delete-button clickable"
              svgIcon="close"
              matTooltip="Verwijder bestand"
              [matTooltipPosition]="'above'"
              (click)="removePdf(pdf)"
            ></mat-icon>
          </div>
        </li>
      </ul>
    </div>
  </div>
</div>

<ng-container *ngIf="!oldSystemImmo">
  <div *ngIf="displayImmoscoopOption" class="d-flex">
    <img src="/assets/immoscoop_banner.png" class="immoscoop-logo" />
    <div class="left-space">
      <yes-no
        [title]="'Mag het Immoscoop logo toegevoegd worden?'"
        [neverShowExtraInstructions]="true"
        [value]="ipBoard.immoscoopLogo"
        [nullIsFalse]="false"
        [nullable]="true"
        (answer)="immoscoopLogoChanged($event)"
      ></yes-no>
    </div>
  </div>
  <div *ngIf="displaySpottoOption" class="d-flex">
    <img src="/assets/spotto_banner.png" class="spotto-logo" />
    <div class="left-space">
      <yes-no
        [title]="'Mag het Spotto logo toegevoegd worden?'"
        [neverShowExtraInstructions]="true"
        [value]="ipBoard.spottoLogo"
        [nullIsFalse]="false"
        [nullable]="true"
        (answer)="spottoLogoChanged($event)"
      ></yes-no>
    </div>
  </div>

  <div class="upper-space">
    <ip-board-extra-board-input
      [ipBoard]="ipBoard"
      (save)="save.emit()"
    ></ip-board-extra-board-input>

    <ng-container
      *ngTemplateOutlet="
        sticker;
        context: {
          collaborative: project.collaborative,
          ipBoard: ipBoard,
          ipBoardPart: ipBoard.boardPart,
          title: 'Links'
        }
      "
    ></ng-container>
    <ng-container *ngIf="ipBoard.leftRightBoard">
      <ng-container
        *ngTemplateOutlet="
          sticker;
          context: {
            collaborative: project.collaborative,
            ipBoard: ipBoard,
            ipBoardPart: ipBoard.otherSideBoardPart,
            title: 'Rechts'
          }
        "
      ></ng-container>
    </ng-container>

    <mat-checkbox
      *ngIf="
        !project.collaborative &&
        ((!ipBoard.leftRightBoard && ipBoard.boardPart.sign != null) ||
          (ipBoard.leftRightBoard &&
            ipBoard.boardPart.sign != null &&
            ipBoard.otherSideBoardPart.sign != null))
      "
      [(ngModel)]="ipBoard.draftDesign"
      (ngModelChange)="draftDesignChanged()"
      ><span class="strong"
        >Ik wens eerst een ontwerp te ontvangen (+ 15 €)</span
      ></mat-checkbox
    >
  </div>
</ng-container>

<ng-template
  #title
  let-collaborative="collaborative"
  let-ipBoard="ipBoard"
  let-ipBoardPart="ipBoardPart"
  let-title="title"
>
  <ng-container
    *ngIf="!collaborative && ipBoardPart.sign != null; else collaborativeTitle"
  >
    <ip-board-title-picker
      [ipBoard]="ipBoard"
      [ipBoardPart]="ipBoardPart"
      [label]="title"
      (save)="save.emit()"
    ></ip-board-title-picker>
  </ng-container>
  <ng-template #collaborativeTitle>
    <ip-board-collaborative-title-picker
      [ipBoardPart]="ipBoardPart"
      [leftRightBoard]="ipBoard.leftRightBoard"
      [label]="title"
      (save)="save.emit()"
    ></ip-board-collaborative-title-picker>
  </ng-template>
</ng-template>

<ng-template
  #phone
  let-collaborative="collaborative"
  let-ipBoard="ipBoard"
  let-ipBoardPart="ipBoardPart"
  let-title="title"
>
  <ng-container
    *ngIf="!collaborative && ipBoardPart.sign != null; else collaborativePhone"
  >
    <ip-board-phone-number-picker
      [ipBoard]="ipBoard"
      [ipBoardPart]="ipBoardPart"
      [label]="title"
      (save)="save.emit()"
    ></ip-board-phone-number-picker>
  </ng-container>
  <ng-template #collaborativePhone>
    <div *ngIf="!oldSystemImmo" class="upper-space">
      <ng-container *ngIf="project.collaborative; else customPhoneNumberPicker">
        <ip-board-part-phone-number-picker
          *ngFor="let options of boardPartPhoneNumberWithOptions"
          [phoneNumberWithOptions]="options"
          (save)="save.emit()"
        ></ip-board-part-phone-number-picker>
      </ng-container>
      <ng-template #customPhoneNumberPicker>
        <ip-board-custom-board-phone-number-picker
          [ipBoardPart]="ipBoardPart"
          [project]="project"
          [otherContacts]="otherContacts"
          [leftRightBoard]="ipBoard.leftRightBoard"
          [label]="title"
          (save)="save.emit()"
        ></ip-board-custom-board-phone-number-picker>
      </ng-template>
    </div>
  </ng-template>
</ng-template>

<ng-template
  #text
  let-ipBoard="ipBoard"
  let-ipBoardPart="ipBoardPart"
  let-title="title"
>
  <div class="upper-space">
    <ip-board-text-input
      [ipBoard]="ipBoard"
      [ipBoardPart]="ipBoardPart"
      [label]="title"
      (save)="save.emit()"
    ></ip-board-text-input>
  </div>
</ng-template>

<ng-template
  #sticker
  let-collaborative="collaborative"
  let-ipBoard="ipBoard"
  let-ipBoardPart="ipBoardPart"
  let-title="title"
>
  <ng-container *ngIf="!collaborative; else collaborativeSticker">
    <ip-board-sticker-picker
      [ipBoard]="ipBoard"
      [ipBoardPart]="ipBoardPart"
      [label]="title"
      (save)="save.emit()"
    ></ip-board-sticker-picker>
  </ng-container>
  <ng-template #collaborativeSticker>
    <ip-board-collaborative-sticker-input
      [ipBoard]="ipBoard"
      [ipBoardPart]="ipBoardPart"
      [label]="title"
      (save)="save.emit()"
    ></ip-board-collaborative-sticker-input>
  </ng-template>
</ng-template>
